import { useMutation, useQueryClient } from "react-query";
import { makeAuthedRequest } from "shared/utils/makeAuthedRequest";

export function useNotes({ id, notes }) {
  const queryClient = useQueryClient();

  // TODO: Optimistic updates

  const addNoteMutation = useMutation(
    (note) =>
      makeAuthedRequest("/prospects/note", {
        method: "post",
        body: JSON.stringify(note),
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries(`/contacts/${id}`);
      },
    }
  );

  const updateNoteMutation = useMutation(
    (note) =>
      makeAuthedRequest("/prospects/note", {
        method: "put",
        body: JSON.stringify(note),
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries(`/contacts/${id}`);
      },
    }
  );

  const deleteNoteMutation = useMutation(
    (noteId) =>
      makeAuthedRequest("/prospects/note", {
        method: "delete",
        body: JSON.stringify({
          contactId: id,
          noteId,
        }),
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries(`/contacts/${id}`);
      },
    }
  );

  return {
    notes,
    addNoteMutation,
    updateNoteMutation,
    deleteNoteMutation,
  };
}
